<template>
  <div class="details_content_car">
    <div class="details_content_repeat">
      <QS-h4-title title="出入库记录" />
      <div class="details_content_repeat_hundred">
        <!--bodyList 表格请求的数据-->
        <table-component
          :data="tableData"
          :columns="tableColumns"
          :total="pagination.total"
          :pageNum="pagination.pageNum"
          :pageSize="pagination.pageSize"
          :hideOnSinglePage="false"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
          v-loading="oLoading.search"
          :paginationAlign="newTableComponentOptions.paginationAlign"
          :headerRowStyle="newTableComponentOptions.headerBackground"
        ></table-component>
      </div>
    </div>
  </div>
</template>

<script>
import CARDICT from '@/store/dict/carDict.js'
import SelectOption from '@/store/dict/selectOptionDict'
import { getOutInList } from '@/api/domain/cars'

export default {
  name: 'StockInOuRecord',
  data() {
    return {
      oLoading: {
        search: false,
      },
      // 订单收款
      tableColumns: [
        {
          label: '出入库ID',
          key: 'id',
        },
        {
          label: '车牌号',
          key: 'plateNo',
          width: 100,
        },
        {
          label: '品牌',
          key: 'brandName',
        },
        {
          label: '车系',
          key: 'seriesName',
        },
        {
          label: '车型',
          key: 'modelName',
          width: 160,
        },
        {
          label: '出入库类型',
          key: 'type',
          source: CARDICT.OUT_INT_TYPE(),
        },
        {
          label: '出入库状态',
          key: 'state',
          formatter: (item, row) => {
            // 待处理
            if (row.state === 0) {
              if (row.type === 1) {
                return '待出库'
              } else if (row.type === 2) {
                return '待入库'
              } else {
                return '--'
              }
            } else {
              return SelectOption.outInState[row.state]
            }
          },
        },
        {
          label: '是否上传验车单',
          key: 'hasInspection',
          formatter: (item, row) => {
            if (row.hasInspection) {
              return '是'
            } else {
              return '否'
            }
          },
        },
        {
          label: '交接完成时间',
          key: 'takeOverTime',
          width: 160,
        },
      ],
      // 列表数据
      tableData: [],
      pagination: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
    }
  },
  mounted() {
    this.getOutInList()
  },
  inject: ['orderData'],
  methods: {
    // 获取出入库列表
    async getOutInList() {
      try {
        this.oLoading.search = true
        const { code, data } = await getOutInList({
          pageSize: this.pagination.pageSize,
          pageNum: this.pagination.pageNum,
          contractId: this.orderData.orderId || this.$route.query.id, // 无权限时取router query的值，不然后端无法判断出入库记录是否有权限
        })
        this.oLoading.search = false
        if (code === 1) {
          this.pagination.total = data.totalNum
          this.tableData = data.items
        } else {
          this.pagination.total = 0
          this.tableData = []
        }
      } catch {
        this.tableData = []
        this.pagination.total = 0
        this.oLoading.search = false
      }
    },
    sizeChange(pageSize) {
      this.pagination.pageNum = 1
      this.pagination.pageSize = pageSize
      this.getOutInList()
    },
    currentChange(pageNum) {
      this.pagination.pageNum = pageNum
      this.getOutInList()
    },
  },
}
</script>

